import { Flex } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import {
  MangoButton,
  MangoButtonVariant,
} from '~/components/shared/MangoButton'
import { Size } from '~/types/ThemeTypes'

export const MessageButtons = (props: {
  handleOpenMango: () => void
  handleDismiss: () => void
}) => {
  const { t } = useTranslation()
  const { handleOpenMango, handleDismiss } = props

  return (
    <Flex paddingTop={1} gap={4}>
      <MangoButton
        onClick={handleDismiss}
        variant={MangoButtonVariant.Neutral_200}
        size={Size.sm}
        flex={1}
      >
        {t('popup.messageButtons.dismiss')}
      </MangoButton>
      <MangoButton
        onClick={handleOpenMango}
        variant={MangoButtonVariant.Default_300}
        size={Size.sm}
        flex={1}
      >
        {t('popup.messageButtons.openMessage')}
      </MangoButton>
    </Flex>
  )
}
